'use client';

import React from 'react';
import MatrixGrid from '@/app/components/MatrixGrid';
import CasinoPartnerCard from '@/app/components/CasinoPartnerCard';
import { casinoPartners } from '@/app/lib/casinoPartners';

export default function BonusesPage() {
    return (
        <div className="mt-15 text-gray-200 min-h-screen overflow-hidden relative">
            <MatrixGrid />
            <div className="flex flex-col items-center justify-center space-y-8 relative z-10 max-w-7xl mx-auto px-4 py-16">
                {/* Header */}
                <div className="text-center mb-12">
                    <h1 className="text-4xl md:text-6xl font-mono font-bold tracking-widest mb-4">
                        <span className="bg-gradient-to-r from-green-400 via-emerald-300 to-green-500 bg-clip-text text-transparent">
                            EXCLUSIVE BONUSES
                        </span>
                    </h1>
                    <p className="uppercase text-green-300 font-mono text-sm md:text-base">
                        <span className="inline-block animate-pulse">{'['}</span> Claim incredible rewards at our partners <span className="inline-block animate-pulse">{']'}</span>
                    </p>
                </div>

                {/* Casino Cards */}
                <div className="w-full space-y-6 mb-8">
                    {casinoPartners.map((casino, index) => (
                        <CasinoPartnerCard key={index} casino={casino} />
                    ))}
                </div>

                {/* How to Claim Section */}
                <div className="w-full backdrop-blur shadow-sm rounded-2xl overflow-hidden backdrop-blur border-b border-green-400/30 rounded-lg p-8">
                    <h2 className="text-2xl md:text-4xl font-mono font-bold text-center mb-8 text-green-400">
                        <span className="inline-block animate-pulse">{'['}</span> HOW TO CLAIM <span className="inline-block animate-pulse">{']'}</span>
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                        {[
                            { step: '1', title: 'Choose Casino', desc: 'Select your preferred casino above' },
                            { step: '2', title: 'Sign Up', desc: 'Create account using our link' },
                            { step: '3', title: 'Use Code (optional)', desc: 'Enter promo code: SOKOLOCO' },
                            { step: '4', title: 'Deposit & Play', desc: 'Bonus credited instantly' }
                        ].map((item, idx) => (
                            <div key={idx} className="text-center group/step">
                                <div className="inline-flex items-center justify-center w-12 h-12 bg-green-500 rounded-full text-black text-xl font-bold mb-3 transition-transform duration-300 group-hover/step:scale-110 group-hover/step:rotate-12">
                                    {item.step}
                                </div>
                                <h4 className="text-lg font-mono font-bold text-green-400 mb-2">
                                    {item.title}
                                </h4>
                                <p className="text-sm text-gray-300 font-mono">
                                    {item.desc}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}